import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { BrowserRouter } from "react-router-dom";
import "@ant-design/v5-patch-for-react-19";
import "antd/dist/reset.css";
import App from "./App";
import "./styles/typography.css";
import "./styles/app.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 10_000, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      button={{ autoInsertSpace: false }}
      theme={{
        token: {
          colorPrimary: "#1769ff",
          colorInfo: "#1769ff",
          colorSuccess: "#16a36a",
          colorWarning: "#f59e0b",
          colorError: "#ef4444",
          colorText: "#172033",
          colorTextSecondary: "#667085",
          colorBgLayout: "#f5f7fb",
          colorBorderSecondary: "#e8ecf3",
          borderRadius: 8,
          borderRadiusLG: 10,
          fontFamily: "var(--font-ui)",
          fontFamilyCode: "var(--font-mono)",
          fontSize: 14,
          fontSizeHeading1: 26,
          fontWeightStrong: 600,
          lineHeight: 1.65,
        },
        components: {
          Button: { controlHeight: 36, primaryShadow: "0 4px 12px rgba(23, 105, 255, .18)" },
          Card: { headerBg: "transparent", headerFontSize: 16 },
          Table: { headerBg: "#fafbfc", headerColor: "#667085" },
          Tag: { fontSizeSM: 14 },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AntdApp>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AntdApp>
      </QueryClientProvider>
    </ConfigProvider>
  </StrictMode>,
);
